/* eslint-disable no-prototype-builtins */
import { RobotChatConfig } from './types';
import { useConfig } from './hooks/useConfig';
import { VueConstructor } from 'vue';
import { useMessage, genMessageId } from './hooks/useMessage';
import { useRender } from './hooks/useRender';
import { RobotMessage } from './dataType';
import transformContent from './util/transformContent';
import 'common-module/src/util/markdown.css';
import { useRootInstance } from '../common-module/src/util/useRootInstance';

const varName = '$robotChat';
const { openRobotChat, closeRobotChat, isRender } = useRender();

const trackHelper = <T>(message: RobotMessage<T>) => {
  if ((message.content as any)?.report?.base?.intentCode === 'knowledge_qa') {
    const instance = useRootInstance();
    const reportData = (message.content as any)?.report?.reportData;
    const source = [];
    if (reportData.source?.doc?.length > 0) {
      source.push('doc');
    }
    if (reportData.source?.issue?.length > 0) {
      source.push('issue');
    }
    // @ts-ignore
    instance.$track?.send('WebIM_AnswerResult', {
      Has_Result: reportData.known_answer,
      AnswerSource_Type: source
    }, true);
  }
};

export function receiveMessage<T> (message: RobotMessage<T>) {
  if (!isRender.value) {
    return;
  }

  if (message.type === 'ai.input.text') {
    // TODO 这里暂时无法确认消息id的唯一性，所以暂时不做处理
    return;
  }

  const { findMessageForAddOrUpdate } = useMessage();

  findMessageForAddOrUpdate(message);

  trackHelper(message);
}

export {
  openRobotChat,
  closeRobotChat,
  isRender,
  transformContent,
  genMessageId
};

export default {
  install(Vue: VueConstructor, config?: RobotChatConfig) {
    useConfig(config);
    if (!Vue.prototype.hasOwnProperty(varName)) {
      // $FlowFixMe
      Object.defineProperty(Vue.prototype, varName, {
        get () {
          return {
            open: openRobotChat,
            close: closeRobotChat,
            isRender,
            receiveMessage
          };
        }
      });
    }
  }
};
